<template>
  <div>
    <el-dialog title="Generar comprobante desde múltiples notas" :visible="show" @open="onOpened"
      :close-on-click-modal="false" :close-on-press-escape="false" @close="onClose" custom-class="pos-payment-dialog">
      <div class="row">
        <div class="col-2">
          <el-select v-model="filter.type" @click="onFetchClients" :disabled="loading">
            <el-option key="document" value="document" label="# de documento"></el-option>
            <el-option key="name" value="name" label="Nombres"></el-option>
          </el-select>
        </div>
        <div class="col-3 form-group">
          <el-select v-model="form.client_id" filterable remote reserve-keyword placeholder="Ingrese uno más caracteres"
            :remote-method="onFindClients" :loading="loading">
            <el-option v-for="item in clients" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="col-3 form-group">
          <el-date-picker v-model="form.date_of_issue" type="date" style="width: 100%"
            placeholder="Inicio Fecha de emisión" value-format="yyyy-MM-dd">
          </el-date-picker>
        </div>
        <div class="col-3 form-group">
          <el-date-picker v-model="form.date_of_due" type="date" style="width: 100%"
            placeholder="Final Fecha de emisión" value-format="yyyy-MM-dd">
          </el-date-picker>
        </div>
        <div class="col-2 form-group">
          <el-button class="btn-block" @click="onFindNotes" type="primary">
            <i class="fa fa-search"></i>
          </el-button>
        </div>
      </div>
      <div class="table-responsive pt-5" v-if="notes">
        <span>Seleccione una o más notas de venta para poder continuar</span>
        <div v-if="errors.notes_id" class="alert alert-warning" role="alert">
          {{ errors.notes_id[0] }}
        </div>
        <table class="table table-hover table-stripe">
          <thead>
            <tr>
              <th></th>
              <th>Nota</th>
              <th>Fecha de emisión</th>
              <th>Monto</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="dis in notes" :key="dis.id">
              <td>
                <el-switch v-model="dis.selected" @change="onFillSelectedNotes"></el-switch>
              </td>
              <td>
                <span>{{ dis.series }}</span>-
                <span>{{ dis.number | pad(0, 3) }}</span>
              </td>
              <td>{{ dis.date_of_issue | toDate }}</td>
              <td>{{ dis.total }}</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td>Total</td>
              <td>{{ this.sum_total }}</td>
            </tr>
          </tbody>
        </table>
        <div class="text-center">
          <el-button v-if="form.selecteds.length > 0" type="primary" :disabled="loading"
            @click="onFetchNoteItems">Generar CPE</el-button>
          <el-button :disabled="loading" @click="onClose">Cerrar</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      required: true,
      type: Boolean,
    },
  },
  data() {
    return {
      title: "",
      loading: false,
      clients: [],
      filter: {
        type: "name",
        name: null,
      },
      form: {
        client_id: null,
        selecteds: [],
      },
      notes: [],
      errors: {},
      group_items_generate_document: false,
      sum_total: null,
    };
  },
  methods: {
    getObjectForNote(data) {
      return {
        number_full: `${data.series}-${data.number}`,
        id: data.id,
        items: data.items,
      }
    },
    hasSaleNoteDetail(value) {
      if (value === null || typeof value === "undefined") {
        return false;
      }

      if (Array.isArray(value)) {
        return value.length > 0;
      }

      if (typeof value === "object") {
        return Object.keys(value).length > 0;
      }

      return String(value).trim() !== "";
    },

    canGroupSaleNoteItem(row) {
      const item = row.item || {};

      /*
       * Los productos con información especial se mantienen separados.
       * Así no se alteran descuentos, cargos, lotes, series, conjuntos,
       * ISC, ICBPER ni información adicional.
       */
      return (
        !this.hasSaleNoteDetail(row.discounts) &&
        !this.hasSaleNoteDetail(row.charges) &&
        !this.hasSaleNoteDetail(row.attributes) &&
        !this.hasSaleNoteDetail(row.additional_information) &&
        !item.series_enabled &&
        !item.lots_enabled &&
        !item.is_set &&
        !item.has_isc &&
        !item.has_plastic_bag_taxes
      );
    },

    getSaleNoteItemGroupKey(row) {
      /*
       * Si la línea tiene características especiales, su ID evita que
       * sea agrupada accidentalmente con otra línea.
       */
      if (!this.canGroupSaleNoteItem(row)) {
        return `sale-note-item:${row.id}`;
      }

      const item = row.item || {};

      /*
       * Dos líneas solamente se agrupan cuando todos sus valores
       * económicos y descriptivos coinciden.
       *
       * Un producto vendido a S/ 1 y otro a S/ 2 generará dos líneas.
       */
      return JSON.stringify({
        item_id: row.item_id,
        unit_price: String(row.unit_price),
        unit_value: String(row.unit_value),
        affectation_igv_type_id: row.affectation_igv_type_id,
        price_type_id: row.price_type_id,
        percentage_igv: String(row.percentage_igv || 0),
        percentage_other_taxes: String(row.percentage_other_taxes || 0),
        warehouse_id: row.warehouse_id || null,
        currency_type_id: item.currency_type_id || null,
        unit_type_id: item.unit_type_id || null,
        description: item.description || null,
        name_product_pdf: row.name_product_pdf || null,
        presentation: item.presentation || null,
      });
    },

    sumSaleNoteItemRows(target, source) {
      /*
       * Se suman solamente cantidades y totales.
       * Los precios unitarios no se modifican porque ya fueron
       * comprobados en getSaleNoteItemGroupKey().
       */
      const numericFields = [
        "quantity",
        "total_value",
        "total_base_igv",
        "total_igv",
        "total_base_isc",
        "total_isc",
        "total_base_other_taxes",
        "total_other_taxes",
        "total_taxes",
        "total_plastic_bag_taxes",
        "total_charge",
        "total_discount",
        "total",
      ];

      numericFields.forEach((field) => {
        const currentValue = parseFloat(target[field] || 0);
        const incomingValue = parseFloat(source[field] || 0);

        target[field] = Number(
          (currentValue + incomingValue).toFixed(10)
        );
      });

      return target;
    },

    groupSaleNoteItems(items) {
      const groupedItems = [];
      const positions = Object.create(null);

      items.forEach((row) => {
        const currentRow = JSON.parse(JSON.stringify(row));
        const groupKey = this.getSaleNoteItemGroupKey(currentRow);

        if (Object.prototype.hasOwnProperty.call(positions, groupKey)) {
          const position = positions[groupKey];

          this.sumSaleNoteItemRows(
            groupedItems[position],
            currentRow
          );
        } else {
          positions[groupKey] = groupedItems.length;
          groupedItems.push(currentRow);
        }
      });

      return groupedItems;
    },
    onFetchNoteItems() {
      if (this.form.selecteds.length === 0) {
        this.$message({
          message: "Seleccione una o más notas de venta por favor",
          type: "warning",
        });

        return;
      }

      this.loading = true;

      if (this.group_items_generate_document) {
        const data = {
          notes_id: this.form.selecteds,
          preserve_sale_values: true,
        };

        this.$http
          .post("/sale-notes/items", data)
          .then((response) => {
            const notes = [];

            this.notes.forEach((note) => {
              if (note.selected) {
                notes.push(this.getObjectForNote(note));
              }
            });

            /*
             * Se agrupan las líneas usando los precios históricos
             * devueltos por sale_note_items.
             */
            const items = this.groupSaleNoteItems(
              response.data.data
            );

            const client = this.clients.find(
              (customer) => customer.id === this.form.client_id
            );

            /*
             * Se elimina cualquier información residual de un intento
             * anterior antes de registrar el nuevo flujo.
             */
            localStorage.removeItem("itemsForNotes");
            localStorage.removeItem("itemsNotGroupForNotes");

            localStorage.setItem(
              "client",
              JSON.stringify(client)
            );

            /*
             * Esta entrada ya es procesada correctamente por
             * invoice_generate.vue sin consultar nuevamente el precio
             * vigente del catálogo.
             */
            localStorage.setItem(
              "itemsNotGroupForNotes",
              JSON.stringify(items)
            );

            localStorage.setItem(
              "notes",
              JSON.stringify(notes)
            );

            this.onClose();
            window.location.href = "/documents/create";
          })
          .catch((error) => this.axiosError(error))
          .finally(() => {
            this.loading = false;
          });
      } else {
        /*
         * El comportamiento existente sin agrupación no se modifica.
         */
        this.processNotGroupItems();
      }
    },
    processNotGroupItems() {

      const data = {
        notes_id: this.form.selecteds,
        select_all: true
      };

      this.$http.post("/sale-notes/items", data)
        .then((response) => {

          const notes = [];
          this.notes.map((d) => {
            if (d.selected) {
              // notes.push(`${d.series}-${d.number}`);
              notes.push(this.getObjectForNote(d))
            }
          });

          const items = response.data.data;

          const client = this.clients.find((c) => c.id === this.form.client_id);
          localStorage.setItem("client", JSON.stringify(client));
          localStorage.setItem("itemsNotGroupForNotes", JSON.stringify(items));
          localStorage.setItem("notes", JSON.stringify(notes));
          this.onClose();
          window.location.href = "/documents/create";
        })
        .catch((error) => this.axiosError(error))
        .finally(() => (this.loading = false));


    },
    onFillSelectedNotes() {
      this.form.selecteds = [];
      this.sum_total = 0;
      let total = 0;
      this.notes.map((d) => {
        if (d.selected) {
          total += d.total;
          this.form.selecteds.push(d.id);
        }
      });
      this.sum_total += total;
    },
    onFindNotes() {
      this.form.selecteds = [];
      this.loading = true;
      const params = this.form;
      this.$http
        .get(`/sale-notes/list-by-client`, { params })
        .then((response) => {
          /* this.sum_total = response.data.sum_total; */
          this.notes = response.data.data.map((d) => {

            d.selected = false;

            d.items = d.items.map((item) => {
              return {
                id: item.id,
                item_id: item.item_id,
              }
            })

            return d;
          });
        })
        .finally(() => (this.loading = false));
    },
    onFindClients(query) {
      this.filter.name = query;
      this.onFetchClients();
    },
    onFetchClients() {
      this.loading = true;
      this.notes = [];
      this.form.selecteds = [];
      const params = this.filter;
      this.$http
        .get("/customers/list", { params })
        .then((response) => {
          this.clients = response.data.data;
        })
        .finally(() => (this.loading = false));
    },
    onOpened() {
      this.filter.type = "name";
      this.filter.name = null;
      this.form.client_id = null;
      this.onFetchClients();
      this.getConfigGroupItems();
    },
    getConfigGroupItems() {

      this.$http
        .get("/sale-notes/config-group-items")
        .then((response) => {
          // console.log(response)
          this.group_items_generate_document = response.data.group_items_generate_document
        })

    },
    onClose() {
      this.notes = [];
      this.$emit("update:show", false);
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/js/views/tenant/sale_notes/ModalGenerateCPE.vue